import { BaseQueryFn, createApi } from '@reduxjs/toolkit/query/react';
import { AxiosRequestConfig } from 'axios';
import camelCase from 'lodash/camelCase';
import mapKeys from 'lodash/mapKeys';

import http from 'src/api/http';

import { TAG_TYPES } from './rtk.types';

// Read: https://redux-toolkit.js.org/rtk-query/usage/customizing-queries#axios-basequery

const axiosBaseQuery =
  (): BaseQueryFn<{
    url: string;
    method: AxiosRequestConfig['method'];
    data?: AxiosRequestConfig['data'];
    headers?: AxiosRequestConfig['headers'];
    params?: AxiosRequestConfig['params'];
  }> =>
  async ({ url, method, data, headers, params }) => {
    try {
      const result = await http({ url, method, data, headers, params });
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError as any;
      const status = err.response?.status || err.status;
      const data = err.response?.data || err.data;

      return {
        error: { status, data: data ? mapKeys(data, (v, k) => camelCase(k)) : data },
      };
    }
  };

const api = createApi({
  reducerPath: 'api',
  baseQuery: axiosBaseQuery(),
  endpoints: () => ({}),
  tagTypes: TAG_TYPES,
});

export default api;
